import React, { useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import "./SetQuiz.scss";
import { useDispatch, useSelector } from "react-redux";
import { getPdfData } from "../../../../Redux/resource/resource.action";
import {
  assignmentHistory,
  generateAssignment,
  updateAssignment,
} from "../../../../Redux/Teacher_Panel/Teacher_Resource/resource.action";
import { profileDetails } from "../../../../Redux/profile/profile.action";
import { useClassDivision } from "../../../../Reusable_Components/multiClassDivisionSelector";
import { Loader } from "lucide-react";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import { formatDate } from "../../../../utils/utils";
import { toast } from "react-toastify";

const SetQuiz = (props) => {
  const dispatch = useDispatch();
  const { show, onHide, subjectChapters, onCreate, quizData, editing } = props;

  const dataToUse =
    subjectChapters && Object.keys(subjectChapters).length > 0
      ? subjectChapters
      : {};

  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedClasses, setSelectedClasses] = useState({});
  const [loading, setLoading] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  // Updated state with 'long' type
  const [questions, setQuestions] = useState({
    mcq: 0,
    fib: 0,
    short: 0,
    // long: 0,
  });

  const [details, setDetails] = useState({
    date: "",
    duration: "",
  });
  const [timeState, setTimeState] = useState({
    hr: "12",
    min: "00",
    period: "AM",
  });

  const [resourceList, setResourceList] = useState(null);
  const [materialID, setMaterialID] = useState("");

  const testStore = useSelector((store) => store);
  const resourceStore = useSelector(
    (store) => store?.ResourceManager?.pdfMetaData,
  );

  const teacherDetails = useSelector(
    (state) => state?.ProfileManager?.user_details,
  );

  const {
    uniqueGrades,
    getDivisionsByGrade,
    buildApiPayload,
    buildInitialState,
  } = useClassDivision(teacherDetails?.classes);

  useEffect(() => {
    dispatch(getPdfData());
    dispatch(profileDetails());
  }, [dispatch]);

  useEffect(() => {
    if (resourceStore && teacherDetails?.classes?.length) {
      setResourceList(resourceStore);
    }
  }, [resourceStore, teacherDetails]);

  const handleTimePartChange = (e) => {
    setTimeState({ ...timeState, [e.target.name]: e.target.value });
  };

  // ---------------------------empty all states once preview api called-------------------------------
  useEffect(() => {
    if (show) {
      setSelectedSubject("");
      setSelectedChapter("");
      setSelectedClasses({});
      setDetails({ date: "", duration: "" });
      // setQuestions({ mcq: 0, fib: 0, short: 0, long: 0 });
      setQuestions({ mcq: 0, fib: 0, short: 0 });
    }
  }, [show]);

  const handleDetailChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (quizData?.start_time) {
      setDetails((prev) => ({
        ...prev,
        date: quizData.start_time.split("T")[0],
        duration: quizData.duration,
      }));
    }
    if (quizData?.duration) {
      setDetails((prev) => ({
        ...prev,
        duration: quizData.duration,
      }));
    }
  }, [quizData]);

  useEffect(() => {
    if (quizData?.start_time) {
      const time = quizData.start_time.split("T")[1].substring(0, 5);
      let [hours, minutes] = time.split(":").map(Number);

      const period = hours >= 12 ? "PM" : "AM";

      hours = hours % 12 || 12;

      setTimeState({
        hr: String(hours).padStart(2, "0"),
        min: String(minutes).padStart(2, "0"),
        period,
      });
    }
  }, [quizData]);
  const MAX_TOTAL_QUESTIONS = 100;

  const handleQuestionCount = (type, op) => {
     setQuestions((prev) => {
    if (op === "dec") {
      return { ...prev, [type]: Math.max(0, prev[type] - 1) };
    }

    // op === "inc" — block if total would exceed 100
    const otherTypesTotal = Object.keys(prev)
      .filter((k) => k !== type)
      .reduce((sum, k) => sum + (Number(prev[k]) || 0), 0);

    const currentTotal = otherTypesTotal + (Number(prev[type]) || 0);

    if (currentTotal >= MAX_TOTAL_QUESTIONS) {
      setToastState({
        show: true,
        message: `Total questions cannot exceed ${MAX_TOTAL_QUESTIONS}.`,
        type: "error",
      });

      return prev;
    }

    return {
      ...prev,
      [type]: prev[type] + 1,
    };
  });
  };

  // Helper to display labels nicely
  const getLabel = (type) => {
    if (type === "mcq") return "MCQ";
    if (type === "fib") return "FIB";
    if (type === "short") return "SHORT";
    // if (type === "long") return "LONG Q";
    return type;
  };

const handleQuestionInputChange = (type, value) => {
  // allow clearing the field while typing
  if (value === "") {
    setQuestions((prev) => ({ ...prev, [type]: "" }));
    return;
  }

  const num = Number(value);
  if (Number.isNaN(num) || num < 0) return;

  setQuestions((prev) => {
    const otherTypesTotal = Object.keys(prev)
      .filter((k) => k !== type)
      .reduce((sum, k) => sum + (Number(prev[k]) || 0), 0);

    if (otherTypesTotal + num > MAX_TOTAL_QUESTIONS) {
      const allowedMax = Math.max(0, MAX_TOTAL_QUESTIONS - otherTypesTotal);
      setToastState({
        show: true,
        message: `Total questions cannot exceed ${MAX_TOTAL_QUESTIONS}. Max allowed for ${getLabel(
          type,
        )} is ${allowedMax}.`,
        type: "error",
      });
      return { ...prev, [type]: allowedMax };
    }

    return { ...prev, [type]: num };
  });
};

const handleQuestionInputBlur = (type) => {
  setQuestions((prev) => ({
    ...prev,
    [type]: prev[type] === "" ? 0 : prev[type],
  }));
};

  // -------------------------------------------class options ------------------------------------------
  const handleMultiSelectChange = (e) => {
    const selected = Array.from(e.target.selectedOptions).map(
      (option) => option.value,
    );

    setSelectedClasses(selected[0]);
  };

  // NEW: classes filtered to only those that teach the selected subject
const classesForSubject = useMemo(() => {
  if (!selectedSubject) return [];
  const classes = teacherDetails?.classes || [];
  return classes.filter((cls) =>
    (cls?.subject || []).some(
      (s) => s?.trim()?.toLowerCase() === selectedSubject?.toLowerCase()
    )
  );
}, [teacherDetails, selectedSubject]);

  // ----------------------------------------subject and chapter options -------------------------------

  const subjectChapterMap = useMemo(() => {
    const map = {};

    resourceList?.forEach((item) => {
      const subject = item.subject;
      const chapter = item.chapter;

      // Skip if subject is null/undefined/empty
      if (!subject) return;

      map[subject] ??= new Set();

      // Only add chapter if it's a valid non-empty value
      if (chapter) {
        map[subject].add(chapter);
      }
    });

    // Convert Set → Array
    Object.keys(map).forEach((key) => {
      map[key] = Array.from(map[key]);
    });

    return map;
  }, [resourceList]);

  // -----------------------------------------generate preview api call------------------------------------------

  const parseClassDivision = (value) => {
    if (!value) return { grade: "", division: "" };

    // ensure string
    value = String(value);

    const gradeMatch = value.match(/\d+/);
    const grade = gradeMatch ? gradeMatch[0] : "";

    let division = "";

    if (value.includes("-")) {
      division = value.split("-").pop().trim();
    } else {
      const divMatch = value.match(/[A-Za-z]+$/);
      division = divMatch ? divMatch[0] : "";
    }

    return { grade, division };
  };

  function formatToISO(dateStr, timeObj) {
    let { hr, min, period } = timeObj;

    hr = parseInt(hr, 10);
    min = parseInt(min, 10);

    // convert to 24-hour format
    if (period === "PM" && hr !== 12) hr += 12;
    if (period === "AM" && hr === 12) hr = 0;

    // pad values
    const hh = String(hr).padStart(2, "0");
    const mm = String(min).padStart(2, "0");

    return `${dateStr}T${hh}:${mm}:00+05:30`;
  }

  const handleCreateClick = async () => {
    const start_time = formatToISO(details?.date, timeState);
    const { grade, division } = parseClassDivision(selectedClasses);

    // Required fields validation
    const missingFields = [];
    
    if (!selectedSubject) missingFields.push("Subject");
    if (!selectedChapter) missingFields.push("Chapter");
    if (!grade || !division) missingFields.push("Class");
    if (!details?.date) missingFields.push("Date");
    if (!details?.duration) missingFields.push("Duration");
    if (!start_time) missingFields.push("Start Time");

    if (missingFields.length > 0) {
      setToastState({
        show: true,
        message: `Please fill: ${missingFields.join(", ")}`,
        type: "error",
      });
      return;
    }

    // At least one question type validation
    const hasQuestions =
      Number(questions?.mcq) > 0 ||
      Number(questions?.fib) > 0 ||
      Number(questions?.short) > 0;

    if (!hasQuestions) {
      setToastState({
        show: true,
        message: "Please add at least one question type (MCQ / FIB / Short).",
        type: "error",
        // autoClose: 3000,
      });
      return;
    }

    setLoading(true);

    const finalData = {
      assigned_class: grade,
      division: division,
      material_id: materialID,
      subject: selectedSubject,
      chapter: selectedChapter,
      num_mcq: Number(questions?.mcq) || 0,
      num_short: Number(questions?.fib) || 0,
      num_fill_ups: Number(questions?.short) || 0,
      start_time: start_time,
      duration: details?.duration,
      day: details?.date,
    };

    try {
      const result = await dispatch(generateAssignment(finalData));

      if (result.success !== true) {
        setToastState({
          show: true,
          message: result.message || "Something went wrong! Try again.",
          type: "error",
        });
      } else {
        dispatch(assignmentHistory());
    
         setToastState({
        show: true,
        message: "Assignment generated successfully!",
        type: "success",
      });
        
        setTimeout(() => {
          onCreate(finalData);
        }, 1000);
      }
    } catch (error) {
      console.error("Error creating quiz:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditQuiz = async () => {
    const start_time = formatToISO(details?.date, timeState);
    const { grade, division } = parseClassDivision(selectedClasses);

    const payload = {
      assignment_id: quizData?.assignment_id,
    };

    let hasChange = false;

    // class change
    if (grade && grade !== quizData?.class) {
      payload.assigned_class = grade;
      hasChange = true;
    }

    // division change
    if (division && division !== quizData?.division) {
      payload.assigned_division = division;
      hasChange = true;
    }

    // start_time change
    if (start_time && start_time !== quizData?.start_time) {
      payload.start_time = start_time;
      hasChange = true;
    }

    // duration change
    if (details?.duration && details.duration !== quizData?.duration) {
      payload.duration_minutes = details.duration;
      hasChange = true;
    }

    // if nothing changed
    if (!hasChange) {
      setToastState({
        show: true,
        message: "Nothing is selected to update.",
        type: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const result = await dispatch(updateAssignment(payload));

      if (!result.success) {
        setToastState({
          show: true,
          message: result.message || "Something went wrong! Try again.",
          type: "error",
        });
      } else {
        dispatch(assignmentHistory());
        setToastState({
          show: true,
          message: "Quiz Updated.",
          type: "success",
        });
        onCreate(payload);
      }
    } catch (error) {
      console.error("Error updating quiz:", error);
    } finally {
      setLoading(false);
    }
  };
  const typeMap = {
    mcq: "mcq",
    fib: "fill_in_the_blank",
    short: "short_answer",
  };

  // const toIST = (utcString) => {
  //   const date = new Date(utcString);
  //   return date.toLocaleString("en-IN", {
  //     timeZone: "Asia/Kolkata",
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   });
  // };

  // // Usage
  // toIST("2026-05-23T08:30:00+00:00"); // → "23/05/2026, 02:00 pm"

  return (
    <>
      <style>{`
        @keyframes spin-loader {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-custom {
          animation: spin-loader 1s linear infinite;
        }
      `}</style>

      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className="set-quiz-modal-modern"
        backdrop="static"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <div>
            <h4 className="fw-bold mb-1">
              {editing ? "Edit Quiz Details" : "Create New Quiz"}
            </h4>
            <p className="text-muted fz14 mb-0">
              Select from {Object.keys(dataToUse)?.length} Subjects
            </p>
          </div>
        </Modal.Header>

        <Modal.Body className="pt-4 pb-4">
          {/* SECTION 1: Subject Selection */}
          <div className="section-card mb-4">
            <h6 className="section-title">1. Select Resource</h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Select Subject</label>
                {editing ? (
                  <select className="form-select custom-input" disabled={true}>
                    <option value="">{quizData?.subject}</option>
                  </select>
                ) : (
                  <select
                    className="form-select custom-input"
                    value={selectedSubject}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedSubject(value);
                      setSelectedChapter("");
                      setSelectedClasses({});
                    }}
                    disabled={editing && quizData?.subject}
                  >
                    <option value="">Choose Subject...</option>
                    {Object.keys(subjectChapterMap).map((subject) => (
                      <option key={subject} value={subject}>
                        {subject}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label">Select Chapter</label>

                {editing ? (
                  <select className="form-select custom-input" disabled={true}>
                    <option value="">{quizData?.chapter}</option>
                  </select>
                ) : (
                  <select
                    className="form-select custom-input"
                    value={selectedChapter}
                    onChange={(e) => {
                      setSelectedChapter(e.target.value);
                      setMaterialID(
                        resourceList
                          ?.filter((d) => {
                            if (
                              d?.subject?.toLowerCase() ===
                                selectedSubject?.toLowerCase() &&
                              d?.chapter?.toLowerCase() ===
                                e.target.value?.toLowerCase()
                            ) {
                              return d?.material_id;
                            }
                          })
                          ?.map((d) => d?.material_id),
                      );
                    }}
                    disabled={!selectedSubject}
                  >
                    <option value="">Choose Chapter...</option>
                    {selectedSubject &&
                      subjectChapterMap[selectedSubject]?.map((chapter) => (
                        <option key={chapter} value={chapter}>
                          {chapter}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </div>
          </div>

          {/* SECTION 2: Question Composition */}
          <div className="section-card mb-4">
            <h6 className="section-title">2. Question Composition</h6>
            <div className="row g-2">
              {["mcq", "fib", "short"].map((type) => (
                <div key={type} className="col-3">
                  <div className="q-counter-card h-100">
                    <span
                      className="q-label text-truncate"
                      title={getLabel(type)}
                    >
                      {getLabel(type)}
                    </span>
                    <div className="counter-controls w-100 justify-content-between">
                      <button
                        onClick={() => handleQuestionCount(type, "dec")}
                        disabled={editing}
                      >
                        -
                      </button>

                      <input
                        type="number"
                        min="0"
                        value={
                          editing
                            ? quizData?.assignment_data?.[typeMap[type]]
                                ?.length || 0
                            : questions[type]
                        }
                        onChange={(e) =>
                          handleQuestionInputChange(type, e.target.value)
                        }
                        onBlur={() => handleQuestionInputBlur(type)}
                        readOnly={editing}
                        disabled={editing}
                      />

                      <button
                        onClick={() => handleQuestionCount(type, "inc")}
                        disabled={editing}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* SECTION 3: Class Details */}
          <div className="section-card mb-4">
            <h6 className="section-title">3. Class Details</h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Class</label>
                <select
                  className="form-select custom-input"
                  value={selectedClasses}
                  onChange={handleMultiSelectChange}
                  disabled={!editing && !selectedSubject}
                >
                  <option value="">
                    {editing
                      ? `${quizData?.class}${quizData?.division}`
                      : selectedSubject
                        ? "Choose Class..."
                        : "Select subject first"}
                  </option>
                  {classesForSubject.map((cls) => {
                    const value = `${cls.grade}${cls.division}`;
                    return (
                      <option key={value} value={value}>
                        {cls.grade}
                        {cls.division}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          {/* SECTION 4: Scheduling */}
          <div className="section-card">
            <h6 className="section-title">4. Scheduling</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  name="date"
                  className="form-control custom-input"
                  value={details.date || ""}
                  onChange={handleDetailChange}
                  min={new Date().toISOString().split("T")[0]} // disable previous dates
                />
              </div>
              <div className="col-md-5">
                <label className="form-label">Start Time</label>
                <div className="d-flex gap-1">
                  <select
                    name="hr"
                    className="form-select custom-input"
                    value={timeState.hr}
                    onChange={handleTimePartChange}
                  >
                    {[12, ...Array.from({ length: 11 }, (_, i) => i + 1)].map(
                      (h) => {
                        const value = String(h).padStart(2, "0");
                        return (
                          <option key={h} value={value}>
                            {value}
                          </option>
                        );
                      },
                    )}
                  </select>
                  <select
                    name="min"
                    className="form-select custom-input"
                    value={timeState.min}
                    onChange={handleTimePartChange}
                  >
                    {Array.from({ length: 12 }, (_, i) => i * 5).map((m) => (
                      <option key={m} value={m < 10 ? `0${m}` : m}>
                        {m < 10 ? `0${m}` : m}
                      </option>
                    ))}
                  </select>
                  <select
                    name="period"
                    className="form-select custom-input"
                    value={timeState.period}
                    onChange={handleTimePartChange}
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label className="form-label">Duration (min)</label>
                <input
                  type="number"
                  name="duration"
                  className="form-control custom-input"
                  placeholder="Min"
                  value={details.duration || ""}
                  onChange={handleDetailChange}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        {editing ? (
          <Modal.Footer className="border-0 pt-0 pb-4 pe-4">
            {" "}
            <button
              className="btn btn-light me-2 fw-medium px-4"
              onClick={onHide}
              disabled={loading}
            >
              {" "}
              Cancel{" "}
            </button>{" "}
            <button
              className="btn btn-primary fw-bold px-5 btn-create d-flex align-items-center justify-content-center"
              onClick={handleEditQuiz}
              disabled={loading}
              style={{ minWidth: "180px" }}
            >
              {" "}
              {loading ? (
                <>
                  <Loader size={20} className="animate-spin-custom me-2" />{" "}
                  <span>Updating...</span>{" "}
                </>
              ) : (
                "Update Quiz"
              )}
            </button>
          </Modal.Footer>
        ) : (
          <Modal.Footer className="border-0 pt-0 pb-4 pe-4">
            <button
              className="btn btn-light me-2 fw-medium px-4"
              onClick={onHide}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary fw-bold px-5 btn-create d-flex align-items-center justify-content-center"
              onClick={handleCreateClick}
              disabled={loading}
              style={{ minWidth: "180px" }}
            >
              {loading ? (
                <>
                  {" "}
                  <Loader size={20} className="animate-spin-custom me-2" />{" "}
                  <span>Creating...</span>{" "}
                </>
              ) : (
                "Create Quiz"
              )}
            </button>
          </Modal.Footer>
        )}
        <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
      </Modal>
    </>
  );
};

export default SetQuiz;
